import * as Yup from 'yup'

import {
  CREATE_CHECKLIST_FIELD_NAME_TEMPLATE,
  CREATE_CHECKLIST_FIELD_NAME_TITLE,
} from '../RequestProfileTabInternalTasks.constants'

export function getCreateChecklistValidationSchema() {
  return Yup.object({
    [CREATE_CHECKLIST_FIELD_NAME_TITLE]: Yup.string()
      .ensure()
      .trim()
      .required(true),
  })
}

export function getCreateChecklistPayload(values) {
  const template = values[CREATE_CHECKLIST_FIELD_NAME_TEMPLATE]

  return {
    name: values[CREATE_CHECKLIST_FIELD_NAME_TITLE],
    template: template?.value,
  }
}
